import { resizeObserver } from '../utils/helpers';

window.addEventListener('DOMContentLoaded', () => {
  resizeObserver.observe(document.body);
});

export {};

const initializeBuilderCollectionDropzone = () => {
  const mountNodes = document.querySelectorAll('.builder-collection-dropzone') as NodeListOf<HTMLElement>;

  if (mountNodes.length > 0) {
    import('./collection/initBuilderCollectionTemplate').then((module) => {
      module.initBuilderCollection(mountNodes);
    });
  }
};

initializeBuilderCollectionDropzone();
